import { postData } from '@/views/mped/services/mped-service';

export const postValidationUploadParams = async (args, area) => {
  return postData({
    url: `/${area}/upload/fact/validation`,
    uuid: '421d7718-dee8-4695-82ce-d23b8c24b730',
    args
  });
}
export const postPreprocessingFactFile = async (args, area) => {
  return postData({
    url: `/${area}/upload/fact/preprocessing`,
    uuid: 'dd01ebd8-c1b2-4b98-a029-061823f83b1c',
    args
  });
}

export const postProcessingFactFile = async (args, area) => {
  return postData({
    url: `/${area}/upload/fact/processing`,
    uuid: '9f17e0bed-2e57-4e78-98cc-493c46992ed4',
    args
  });
}

export const postPostprocessingFactFile = async (args, area) => {
  return postData({
    url: `/${area}/upload/fact/postprocessing`,
    uuid: 'ee24e66f-cc5a-43cd-9cf5-2d0380718bbc',
    args
  });
}
